import React from "react";
import { StringWidget } from "./StringWidget";

export function FolderWidget(props) {

  const actionButtonOptions =
  {
    icon: 'activefolder',
    action: (value) => {
      alert("TBD");
    }
  };

  return (
    <StringWidget
      isBaseWidgetFor="FolderWidget"
      actionButtonOptions={actionButtonOptions}
      {...props}
    />
  );
}